import React from 'react';
import { Form, Select, Input } from '@block/plug';
import { Card } from '../../../components';
import Url from '../url';
import { doAction } from '../../../utils';

interface Props {
  data: any;
  getRef: any;
  index: number;
  onChange: (a: any, b: any) => void;
  onDelete: (e: any) => void;
  hideIcon: any;
}
class DeclarationCard extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {};
  }

  formRef: React.RefObject<any>;

  async componentDidMount() {
    const { data, getRef, index } = this.props;
    getRef && getRef(this.formRef, index);
    this.formRef.current?.setAllFieldsValue(data);
  }

  componentWillReceiveProps(props) {
    const { data } = props;
    this.formRef.current?.setAllFieldsValue(data);
  }

  // 获取最终组织数据
  handleFetchFinalData = () => this.formRef.current.getFieldsValueIncludeHide();

  // 获取数据
  handleFetchSelectData = async (type, params) => {
    let url = '';
    if (type === 'relation') {
      // 亲属关系
      url = Url.getRelation;
    }
    const data = await doAction(url, params);
    return data.pageList;
  };

  handleDelete = () => {
    const { onDelete, index } = this.props;
    if (typeof onDelete === 'function') {
      onDelete(index);
    }
  };

  handleFieldValueChange = () => {
    const ref = this.formRef.current;
    const { onChange, index } = this.props;
    const formData = ref.getFieldsValueIncludeHide();
    if (typeof onChange === 'function') onChange(formData, index);
  };

  render() {
    const { hideIcon, index } = this.props;
    return (
      <Card onDelete={this.handleDelete} hideIcon={hideIcon}>
        <Form
          ref={this.formRef}
          labelWidth="120px"
          className="declaration__card"
          onFieldValueChange={this.handleFieldValueChange}
        >
          <Form.Item formItemKey="isTopDegree" labelWidth="40px">
            <span className="base-form__subtitle">亲属{index + 1}</span>
          </Form.Item>

          <Form.Item formItemKey="name" label="亲属姓名：" required message="不能为空">
            <Input toFormItem maxLength={50} />
          </Form.Item>

          <Form.Item
            formItemKey="relationDictIndex"
            labelInValue={false}
            formItemLabel="relationDictName"
            label="亲属关系："
            required
            message="不能为空"
          >
            <Select
              toFormItem
              keyField="dictIndex"
              labelField="dictValue"
              filterable
              onFetchData={(filter = '') =>
                this.handleFetchSelectData('relation', {
                  filter,
                })
              }
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
              popLayer={{
                getContainer: () => document.querySelector('.declaration__card'),
              }}
            />
          </Form.Item>
          <Form.Item
            formItemKey="phone"
            label="亲属联系电话："
            rules={[
              { required: true, message: '亲属联系电话不能为空' },
              {
                validator(rule, value, callback) {
                  const pattern = /^[0-9]*$/;
                  if (pattern && !pattern.test(value)) {
                    callback('请输入有效的手机号');
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <Input toFormItem />
          </Form.Item>
          <Form.Item formItemKey="remarks" label="补充说明：" required message="不能为空">
            <Input toFormItem maxLength={50} />
          </Form.Item>
        </Form>
      </Card>
    );
  }
}

export default DeclarationCard;
